module.exports =  {
  CONTEST_MAX_CHARACTERS: 270000,
  PAGE_SIZE: 75000,
  ORIGINAL_MAX_CHARACTERS: 90000
}
